module.exports = "/_next/static/images/reset-pin-18c24a137ae85ab21fc9bdab3f82f7fb.svg";